import React from 'react';
import { PositionSuggestion } from '../../services/klineTypes';

interface StopLossPanelProps {
  suggestion: PositionSuggestion | null | undefined;
}

const StopLossPanel: React.FC<StopLossPanelProps> = ({ suggestion }) => {
  if (!suggestion) return null;

  const getActionColor = (action: string) => {
    switch (action) {
      case 'close':
        return 'text-red-400';
      case 'reduce':
        return 'text-yellow-400';
      case 'hold':
        return 'text-green-400';
      default:
        return 'text-white';
    }
  };

  const getActionText = (action: string) => {
    switch (action) {
      case 'close':
        return '建议平仓';
      case 'reduce':
        return '建议减仓';
      case 'hold':
        return '建议持有';
      default:
        return action;
    }
  };

  return (
    <div className="bg-white/5 border border-white/10 rounded-lg p-4 mb-4">
      <h3 className="text-sm font-semibold text-white/90 mb-3 flex items-center gap-2">
        <svg className="w-4 h-4 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
        持仓风控建议
      </h3>
      <div className="space-y-3">
        <div className="flex items-start justify-between">
          <span className="text-white/60 text-sm">建议操作</span>
          <span className={`font-bold ${getActionColor(suggestion.action)}`}>{getActionText(suggestion.action)}</span>
        </div>

        {suggestion.suggestedTakeProfitPrice !== undefined && (
          <div className="flex items-start justify-between">
            <span className="text-white/60 text-sm">建议止盈价</span>
            <span className="font-mono text-green-400">{suggestion.suggestedTakeProfitPrice}</span>
          </div>
        )}

        {suggestion.suggestedStopPrice !== undefined && (
          <div className="flex items-start justify-between">
            <span className="text-white/60 text-sm">建议止损价</span>
            <span className="font-mono text-red-400">{suggestion.suggestedStopPrice}</span>
          </div>
        )}

        <div className="bg-white/5 rounded p-3 text-sm text-white/80">{suggestion.reason}</div>
      </div>
    </div>
  );
};

export default StopLossPanel;
